.center-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 1.6rem;
  justify-content: space-between;
  width: 100%;
}

.day-text {
  color: var(--color-texts-high-contrast);
  line-height: 1.8rem;
}

.end-of-day {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 400;
  font-size: 1.4rem;
  padding: 0.8rem;
}
